import { Record } from 'immutable';

import { FETCH_FAILURE, FETCH_REQUEST, FETCH_SUCCESS } from './actionDefinitions';

const FetchRecord = new Record({
	lastFetchSource: null,
	lastFetchSuccess: undefined,
	lastFetchError: undefined
});

const initialState = new FetchRecord();

const fetch = (state = initialState, action) => {
	switch(action.type) {
		case FETCH_REQUEST:
			return FetchRecord({
				lastFetchSource: action.payload.source,
				lastFetchSuccess: undefined,
				lastFetchError: undefined
			});
		case FETCH_SUCCESS:
			return FetchRecord({
				lastFetchSource: action.payload.source,
				lastFetchSuccess: true,
				lastFetchError: undefined
			});
		case FETCH_FAILURE:
			return FetchRecord({
				lastFetchSource: action.payload.source,
				lastFetchSuccess: false,
				lastFetchError: action.payload.error.responseText || 'general error'
			});
		default:
			return state;
	}
};

export default fetch;
